




















































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import CONFIG from '@/common/config';
import CallPhone from '@/pages/showDetail/CallPhone.vue';
import { Grade, Gender } from '@/common/interface';
import { formatMoney } from '../../common/utils/format';
import PageLoading from '@/pages/showDetail/PageLoading.vue';
import Tooltip from '@/components/common/index/Tooltip.vue';
import FailTooltip from '@/pages/showDetail/FailTooltip.vue';
import { GRADE, GENDER } from '@/common/constants';
import getUrlParam from '@/common/utils/getUrlParam';
import fetch from '@/common/api/fetch';
import Empty from '@/pages/showDetail/Empty.vue';
import Picker from '@/components/common/edit/Picker.vue';
import Bridge from '@/common/bridge';
import Confirm from '@/pages/showDetail/Confirm.vue';
import ConfirmThree from '@/pages/showDetail/ConfirmThree.vue';
import CancelDetailModal from '@/pages/showDetail/CancelDetailModal.vue';
@Component({
  components: {
    'call-phone': CallPhone,
    'show-page-loading': PageLoading,
    'tool-tip': Tooltip,
    'fail-tip':FailTooltip,
    'empty-block': Empty,
    'xm-picker': Picker,
    'xm-confirm': Confirm,
    'xm-confirm-three': ConfirmThree,
    'cancel-detail-modal': CancelDetailModal
  }
})
export default class DistributionList extends Vue {
  @Prop({ required: true }) dataList!: Array<any>;
  @Prop({ required: true }) showDetail!: any;
  @Prop({ required: true }) totalCount!: string;
  @Prop({ required: true }) gradeArr!: Grade[];
  @Prop({ required: true }) genderArr!: Gender[];
  @Prop({ required: true }) getingDetail!: boolean;
  @Prop({ required: true }) channel!: string;
  @Prop({ required: true }) ErrorCodeEnum!: any;
  @Prop({ required: true }) showGuideTip!: boolean;

  loading: any ;
  hasPaid: boolean = true;
  XMCounter: boolean = false;
  tabValue: boolean = true;
  cancelList: any = [];
  showPicker: boolean = false;
  showConfirm: boolean = false;
  chooseItem: any = {};
  detailItem: any = {};
  showDetailModal: boolean = false;
  showConfirmThree: boolean = false;
  showForceConfirm: boolean = false;

  configOption: any = {
    title: '确认取消报名？',
    content: '取消后，家长无法再次报名该活动，但不影响原有的上下级绑定关系，若有其下级报名，佣金仍发放',
    okText: '确定',
    cancleText: '取消',
    cancelColor: '#0076FF',
    okColor: '#0076FF'
  };
  configThreeOption: any = {
    title: '重新发起退款？',
    content: '选择重新退款后，系统会重新发起小麦收银退款，也可选择私下处理，系统将为你生成收支。',
    oneText: '重新退款',
    twoText: '私下处理',
    threeText: '取消'
  };
  configForceOption: any = {
    title: '确认您私下将家长支付款项退给家长？',
    content: '确认后，系统将取消该家长的报名，且对该笔退款生成一条收支明细',
    okText: '确定',
    cancleText: '取消',
    cancelColor: '#0076FF',
    okColor: '#0076FF'
  };

  // 取消报名失败弹窗
  showCancelConfirm: boolean = false;
  configCancelOption: any = {
    title: '取消报名失败',
    content: '',
    okText: '私下处理',
    cancleText: '取消',
    cancelColor: '#0076FF',
    okColor: '#0076FF'
  };

  pickerItem: Array<object> = [
    {
      text: '呼叫',
      color: '#333',
      handler: () => {
        this.handleHidePicker();
        this.handleClickPhone();
      }
    },
    {
      text: '取消报名',
      color: '#333',
      handler: () => {
        this.handleHidePicker();
        this.handleShowModal();
      }
    }
  ];
  created() {
    this.checkUserPermission();
    let tabType = getUrlParam('tabType')
    if (tabType === 'cancel') {
      this.tabValue = false;
      this.getCancelSignIn();
    } else {
      this.tabValue = true;
    }
  }
  get additionalInfo(): Array<string> {
    let additionalInfo: any = [];
    this.dataList.forEach((item: any) => {
      item.additionalInfo ? additionalInfo.push(JSON.parse(item.additionalInfo)) : additionalInfo.push({});
    });
    return additionalInfo;
  }

  get price(): string {
    return formatMoney(this.showDetail.price, 100, true).toFixed(2);
  }

  get totalPayedAmount(): string {
    return formatMoney(this.showDetail.totalPayedAmount, 100, true).toFixed(2);
  }

  changeGradeArr(value: number) {
    if (!value) return null;
    let grade = GRADE.find((item: Grade) => {
      return item.value == value;
    });
    return grade ? grade.label : undefined;
  }

  changeGenderArr(value: number) {
    if (!value) return null;
    let gender = GENDER.find((item: Gender) => {
      return item.value == value;
    });
    return gender ? gender.label : undefined;
  }

  handleChangeTab(hasPaid: boolean = true) {
    this.hasPaid = hasPaid;
    this.$emit('refresh', { hasApply: hasPaid });
  }

  handleToWithdraw() {
    if (this.channel === 'XM_CASHIER') {
      // 新活动-跳转到小麦收银
      if (getUrlParam('instId') && getUrlParam('aid')) {
        const param = {
          instId: getUrlParam('instId'),
          adminId: getUrlParam('aid'),
          groupCode: 'CashWithdrawal'
        };
        fetch.Sales('anon/inst/checkUserPermission', param).then((res: any) => {
          if (res.result) {
            const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
            const hash: string = window.location.hash.split('?')[1];
            const tempStr: string = (CONFIG.hybirdUrl as any)[env] + '/finance/balance?' + hash;
            window.location.replace(tempStr);
          } else {
            Vue.$toast.error('无【小麦收银-提现记录-提现】权限，请联系管理员（主账号）');
          }
        });
      }
    } else {
      // 旧活动-跳转到小麦秀钱包
      const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
      const hash: string = window.location.hash.split('?')[1];
      const tempStr: string = (CONFIG.hybirdUrl as any)[env] + '/pay/wallet?' + hash;
      window.location.replace(tempStr);
    }
  }
  checkUserPermission() {
    const param = {
      instId: getUrlParam('instId'),
      adminId: getUrlParam('aid'),
      groupCode: 'SeeColRecord'
    };
    fetch.Sales('anon/inst/checkUserPermission', param).then((res: any) => {
      this.XMCounter = res.result;
    });
  }
  gotoXMCounter(id: string) {
    if (!this.XMCounter) {
      return;
    }
    let env: string = process.env.VUE_APP_DEPLOY_ENV as string;
    window.location.href = `${(CONFIG.hybirdUrl as any)[env]}/bank/new/wallet/detail?id=${id}&token=${getUrlParam('token')}&instId=${getUrlParam(
      'instId'
    )}&aid=${getUrlParam('aid')}&uid=${getUrlParam('uid')}&v=${getUrlParam('v')}${getUrlParam('vn') ? `&vn=${getUrlParam('vn')}` : ''}`;
  }
  handleChangeTabValue(tabValue: boolean = true) {
    this.tabValue = tabValue;
    if (tabValue === false) {
      this.getCancelSignIn();
    }else {
      this.handleChangeTab();
    }
  }
  // 报名取消记录列表
  getCancelSignIn() {
    const broadcastId = getUrlParam('broadcastId');
    const param = {
      activityId: broadcastId,
      pageNo:0,
      pageSize:0
    };
    fetch.Sales('public/businessShow/getCancelSignIn', param).then((res: any) => {
      const { records } = res.result || {};
      this.cancelList = records;
    });
  }
  handleShowPicker(item: any, current: number) {
    this.showPicker = true;
    this.chooseItem = item;
  }
  openDetailCancel(item: any) {
    this.showDetailModal = true;
    this.detailItem = item;
  }
  // 关闭所有确认弹窗
  handleHideConfirm() {
    this.showConfirm = false;
    this.showForceConfirm = false;
    this.showConfirmThree = false;
    this.showCancelConfirm = false;
  }
  handleHidePicker() {
    this.showPicker = false;
  }
  handleShowModal() {
    const param = {
      instId: getUrlParam('instId'),
      adminId: getUrlParam('aid'),
      groupCode: 'DealXmShow'
    };
    fetch.Sales('anon/inst/checkUserPermission', param).then((res: any) => {
      if (res.result) {
        if (this.hasPaid) {
          this.configOption.content = `<div style="text-align:left;padding:0 0.08rem 0 0.12rem">取消后，将自动退款给家长，但佣金为实时到账不可一起退还，<span style="color:#FF4F4F">给家长发放的佣金需要机构承担</span>。 <br/>该家长无法再次报名该活动，但不影响原有的上下级绑定关系，若有其下级报名，佣金仍发放</div>`;
        } else {
          this.configOption.content = '取消后，家长无法再次报名该活动，但不影响原有的上下级绑定关系，若有其下级报名，佣金仍发放';
        }
        this.showConfirm = true;
      } else {
        Vue.$toast.error('暂无【管理小麦秀】权限，请联系管理员（主账号）');
      }
    });
  }
  handleHideDetail() {
    this.showDetailModal = false;
    this.detailItem = {};
  }
  // 取消报名
  handleCancelItem() {
    this.loading = window.weui.loading('正在处理中，请稍后~');
    const broadcastId = getUrlParam('broadcastId');
    const aid = getUrlParam('aid');
    const param = {
      activityId: broadcastId,
      userId: this.chooseItem.userId,
    };
    fetch.Sales('public/businessShow/cancelSignIn', param).then((res: any) => {
      const { taskId = '' } = res.result || {};
      this.getCancelSignInResult(taskId);
    });
  }
  getCancelSignInResult(id: any) {
    fetch.Sales('public/businessShow/getCancelSignInResult', { id }).then((res: any) => {
      if (JSON.stringify(res.result) === '{}') {
        setTimeout(() => {
          this.getCancelSignInResult(id);
        }, 500);
      } else {
        this.loading.hide();
        const { errorCode = '', errorMessage = '' } = res.result || {};
        if (errorCode) {
          this.configCancelOption = {
            title: '取消报名失败',
            content: `<span>${this.ErrorCodeEnum[errorCode] || '退款出现异常，无法直接退回至用户账户。'}<span style="color:#FF8534">如仍需退款，请私下处理</span>，系统将为你生成收支。</span>`,
            okText: '私下处理',
            cancleText: '取消',
            cancelColor: '#0076FF',
            okColor: '#0076FF'
          };
          this.handleHideConfirm();
          this.showCancelConfirm = true;
        } else if (errorMessage) {
          Vue.$toast.error(errorMessage);
        } else {
          Vue.$toast.success('取消报名成功，可前往“取消报名记录”中查看');
          this.handleHidePicker();
          this.handleHideConfirm();
          this.$emit('refresh', { hasApply: this.hasPaid });
        }
      }
    });
  }
  // 取消报名失败-私下处理
  forceCancelSignIn() {
    const broadcastId = getUrlParam('broadcastId');
    const aid = getUrlParam('aid');
    const param = {
      activityId: broadcastId,
      userId: this.chooseItem.userId,
    };
    fetch.Sales('public/businessShow/forceCancelSignIn', param).then((res: any) => {
      if (res.success) {
        Vue.$toast.success('取消报名成功，可前往“取消报名记录”中查看');
        this.handleHidePicker();
        this.handleHideConfirm();
        this.$emit('refresh', { hasApply: this.hasPaid });
      }
    });
  }
  // 重新退款
  handleRefundItem(flag: boolean) {
    this.loading = window.weui.loading('正在处理中，请稍后~');
    const broadcastId = getUrlParam('broadcastId');
    const param = {
      activityId: broadcastId,
      force: flag, // flag：true 私下退款
      tradeId: this.chooseItem.tradeId||this.detailItem.tradeId,
    };
    fetch.Sales('public/businessShow/refund', param).then((res: any) => {
      const { taskId = '' } = res.result || {};
      this.getRefundResult(taskId); 
    }).catch(() => {
      this.loading.hide();
    });
  }
  getRefundResult(id: any) {
    fetch.Sales('public/businessShow/getRefundResult', {id}).then((res: any) => {
      if (JSON.stringify(res.result) === '{}') {
        setTimeout(() => {
          this.getRefundResult(id);
        }, 500);
      } else {
        const { errorCode = '', errorMessage='' } = res.result || {};
        this.loading.hide();
        if (errorCode) {
          this.configForceOption = {
            title: '重新退款失败',
            content: `<span>${this.ErrorCodeEnum[errorCode]||'退款出现异常，无法直接退回至用户账户。'}<span style="color:#FF8534">如仍需退款，请私下处理</span>，系统将为你生成收支。</span>`,
            okText: '私下处理',
            cancleText: '取消',
            cancelColor: '#0076FF',
            okColor: '#0076FF'
          };
          this.showConfirmThree = false;
          this.showForceConfirm = true;
        } else if (errorMessage) {
          Vue.$toast.error(errorMessage);
        } else {
          Vue.$toast.success('操作成功');
          this.handleHideConfirm();
          this.handleHideDetail();
          this.getCancelSignIn();
        }
      }
    })
  }
  // 退款详情页面上的重新退款
  handleShowDetailThreeModal() {
    const param = {
      instId: getUrlParam('instId'),
      adminId: getUrlParam('aid'),
      groupCode: 'DealXmShow'
    };
    fetch.Sales('anon/inst/checkUserPermission', param).then((res: any) => {
      if (res.result) {
        this.showConfirmThree = true;
      } else {
        Vue.$toast.error('暂无【管理小麦秀】权限，请联系管理员（主账号）');
      }
    });
  }
  handleShowForce() {
    this.showConfirmThree = false;
    this.configForceOption = {
      title: '确认您私下已将家长支付款项退给家长？',
      content: `确认后，系统将取消该家长的报名，且对该笔退款生成一条收支明细`,
      okText: '确认',
      cancleText: '取消',
      cancelColor: '#0076FF',
      okColor: '#0076FF'
    };
    this.showForceConfirm = true;
  }
  // 打电话
  handleClickPhone(): void {
    Bridge.callHandler((Api: any) => {
      Api.callContact({ number: this.chooseItem.phone });
    });
  }
  handleShowThreeModal(e: any, item: any) {
    e.stopPropagation();
    e.preventDefault();
    const param = {
      instId: getUrlParam('instId'),
      adminId: getUrlParam('aid'),
      groupCode: 'DealXmShow'
    };
    fetch.Sales('anon/inst/checkUserPermission', param).then((res: any) => {
      if (res.result) {
        this.chooseItem = item;
        this.showConfirmThree = true;
      } else {
        Vue.$toast.error('暂无【管理小麦秀】权限，请联系管理员（主账号）');
      }
    });
  }
}
